import { mapValues } from 'lodash';
import { buttonStylingToBlockModelMap } from '../config/editorBlock/stylingKeysToBlockProps';

export const mergeStylingWithBackButtonData = (styling, backButton = {}) => ({
  ...styling,
  ...mapValues(
    buttonStylingToBlockModelMap,
    (val, key) => backButton[val] || styling.meta.localStyling[key],
  ),
});
